// extracted by mini-css-extract-plugin
module.exports = {"journeyContainer":"Journey_journeyContainer__MXquS","nameText":"Journey_nameText__2Z2Gx","childrenContainer":"Journey_childrenContainer__3bRtK"};